



























































import ripple from "../../components/ripple.vue"
import tooltip from "../../components/tooltip.vue"
import gbutton from "../../components/button.vue"
import loadingBar from "../../components/loadingBar.vue"
import gTable, {Rows} from "../../components/table.vue"

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { setInterval } from "timers";
import { frontendClient } from "../../lib/client";

@Component({
    components : {
        ripple,
        loadingBar,
        gbutton,
        gTable,
        tooltip,
    },
})
export default class User extends Vue{
    perc:number = 0;

    completePage:number = 1;
    incompletePage:number = 1;

    incompleteLoad:number = 0;
    completeLoad:number = 0;

    incompleteJobs: Rows[] = [];
    completeJobs: Rows[] = [];

    mounted(){
       this.$emit('scope','jobs');

       this.getJobs();
    };

    getJobs(){
        this.getUncomplete();
        this.getComplete();
    }
    getUncomplete(){
        this.incompleteLoad = 20;
        frontendClient.post('jobs/list',{page:this.incompletePage,hasCompleted: false})
        .then((data) => {
            if(!data.jobs || data.jobs.length == 0){
                this.incompletePage = -1;
                return;
            }
            let divided = 80 / data.jobs.length;
            for(let i=0; i<data.jobs.length; i++){
                this.incompleteLoad += divided
                this.incompleteJobs.push(data.jobs[i]);
            }
            this.incompletePage++;
        })
        .catch((err) => {
            frontendClient.giveError(err);
        })
        .finally(() => {
            this.incompleteLoad = 100;
        })
    }
    getComplete(){
        this.completeLoad = 20;
        frontendClient.post('jobs/list',{page:this.completePage,hasCompleted: true})
        .then((data) => {
            if(!data.jobs || data.jobs.length == 0){
                this.completePage = -1;
                return;
            }
            let divided = 80 / data.jobs.length;
            for(let i=0; i<data.jobs.length; i++){
                this.completeLoad += divided;
                this.completeJobs.push(data.jobs[i]);
            }
            this.completePage++;
        })
        .catch((err) => {
            frontendClient.giveError(err);
        })
        .finally(() => {
            this.completeLoad = 100;
        })
    }
}
